import {
    util,
    cloneDeep
} from 'utils';
import $http from '$http'
//组件
import contactList from 'contact-list-dialog';
import infodialog from 'infodialog';
export default {
    components: {
        'contact-list-dialog': contactList,
        'info-dialog': infodialog
    },
    props: {
        value: {
            type: Boolean,
            required: true,
            default: false
        },
        data: {
            type: Array,
            required: true,
            default: []
        },
        totalSize: {
            type: Number,
            required: true,
            default: 0
        },
        followItem: {
            type: Object,
            default: null
        },
        id: {
            default: 0
        },
        customerId: {
            default: 0
        }
    },
    created() {
        this.visiable = this.value;
    },
    data() {
        return {
            /* 跟进情况列表 */
            value1: '',
            visiable: false,
            loading: false,
            pageIndex: 1,
            pageSizes: [10, 20, 50],
            pageSize: 10,
            showDate: true,
            /* 跟进编辑数据 */
            editBoxVisiable: false, //是否显示编辑对话框
            editBoxTitle: '新增跟进', //编辑对话框标题
            contactListVisiable: false, //是否显示联系人列表对话框
            isVisiable: false, //是否显示添加联系人对话框
            currentContact: {},
            currentFollowId: null,
            followUpData: {
                Customer_Id: 0,
                Contact_Id: 0,
                Contact: '',
                Follow: '',
                FollowDate: '',
                transitionDate: null,
                tDate: null,
                NextFollowDate: '',
                CustomerLevel_Id: '',
                ParentMeetingTime: '',
                OpenOnLineCourse: '',
                C_Tel: ''
            },
            followUpRules: {
                Contact: [{
                    required: true,
                    message: '请选择联系人'
                }],
                CustomerLevel_Id: [{
                    required: true,
                    message: '请选择意向级别'
                }],
                Follow: [{
                    required: true,
                    message: '请输入跟进内容',
                    trigger: 'blur'
                }],
                transitionDate: [{
                    required: true,
                    message: '请选择下次跟进日期'
                }],
                OpenOnLineCourse: [{
                    required: true,
                    message: '请选择是否开通在线课程'
                }],
            },
            contactList: [],
            form: this.getFormData(),
            isShow: false,
            currentId: ""

        }
    },
    computed: {
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
        sysUserName() {
            return this.$store.state.sysUserName;
        },
    },
    watch: {
        value(val) {
            this.visiable = val;
            if (val) return;
            this.currentFollowId = null;
        },
        visiable(val) {
            this.$emit('input', val);
        },
        pageSize(val) {
            this.$emit('refresh-data', 'pageSize', val);
        },
        pageIndex(val) {
            this.$emit('refresh-data', 'pageIndex', val);
        },
        currentContact: {
            deep: true,
            handler: function (contact) {
                this.followUpData.Contact_Id = contact.Id;
                this.followUpData.Contact = contact.C_Name;
                this.followUpData.C_Tel = contact.C_Tel;
            }
        },
        'followUpData.transitionDate': function (date) {
            if (Object.prototype.toString.call(date) !== '[object Date]') return;
            this.followUpData.NextFollowDate = util.time2str(date.getTime(), 'short');

        },
        'followUpData.tDate': function (date) {
            if (Object.prototype.toString.call(date) !== '[object Date]') return;
            this.followUpData.ParentMeetingTime = util.time2str(date.getTime(), 'short');
        },
        followItem(val) {
            this.$nextTick(() => {
                this.followUpData = this.followItem;
                this.followUpData.transitionDate = util.str2date(this.followItem.NextFollowDate);
                this.followUpData.tDate = util.str2date(this.followItem.ParentMeetingTime);
                this.followUpData.CustomerLevel_Id = this.followUpData.CustomerLevel_Id.toString();
            });
        },
        editBoxVisiable(val) {
            if (val) return;
            this.followUpData = {
                Customer_Id: 0,
                Contact_Id: 0,
                Contact: '',
                Follow: '',
                transitionDate: null,
                tDate: null,
                NextFollowDate: '',
                CustomerLevel_Id: '',
                C_Tel: '',
                ParentMeetingTime: ''
            };
            this.currentContact = {};
            this.$refs.followUpForm.resetFields();
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "SchoolId": "",
                "SchoolName": "",
                "PhoneNo": "",
                "PrincipalName": "",
                "Agent": "",
                "PreFollowInfo": "",
                "employee_Id": "",
                "employee_Name": "",
                "FollowId": 0,
                "ContactName": "",
                "Contact_Id": 0,
                "CustomerLevel_Id": 0,
                "NextFollowDate": "",
                "Follow": "",
                "ParentMeetingTime": "",
                "OpenOnLineCourse": "",
                "CustomerLevel_Name": "",
                "C_Tel": ""

            });
        },
        pickChangefn(item) {

            this.$nextTick(() => {
                this.followUpData.NextFollowDate = this.followUpData.transitionDate;

            });
            this.showDate = false;
            this.showDate = true;
        },
        pickChange(item) {
            this.$nextTick(() => {
                this.followUpData.ParentMeetingTime = this.followUpData.tDate;
            });
            this.showDate = false;
            this.showDate = true;
        },
        handleSizeChange(val) {
            this.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
        },
        //获取下拉联系人
        openContactList() {
            this.contactListVisiable = true;
        },
        closeContactList() {
            this.contactListVisiable = false;
        },
        setContact(contact) {
            this.currentContact = contact;
        },
        selectRow(row) {
            if (!row) return;
            this.currentFollowId = row.Id;
        },
        openEditBox(type) {
            this.currentId = this.customerId;
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                CustomerId: this.customerId
            }
            $http.get("api/School/LoadDataForFollow", Params).then(res => {
                util.doResult(this, res, () => {
                    let {
                        Data
                    } = res.data;
                    this.form = Data;
                    if (this.form.PreFollowInfo === 1 && type === 'add') {
                        //console.log(type)
                        this.isShow = true;
                        this.followUpData.Contact = this.form.ContactName
                        this.followUpData.C_Tel = this.form.C_Tel,
                            this.followUpData.Contact_Id = this.form.Contact_Id
                    } else {
                        this.isShow = false;
                    }

                })
            });
            if (type === 'modify' && this.currentFollowId === null) {
                this.$notify({
                    title: '提示',
                    message: '请选择跟进内容！',
                    type: 'warning'
                });
                return;
            }
            var titleMap = {
                'add': '新增跟进',
                'modify': '修改跟进'
            };
            this.editBoxTitle = titleMap[type];

            if (type === 'modify') {
                this.$emit('get-followup-item', this.currentFollowId);
            }

            this.editBoxVisiable = true;
        },
        // 新增联系人
        addDomain() {
            this.isVisiable = true
        },
        // delContactfn(item) {
        //     this.$confirm('确定要删除该联系人，删除后不可恢复？', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.contactList.splice((item.index - 2), 1);
        //     }).catch(() => {
        //         this.$message({
        //             type: 'info',
        //             message: '已取消删除'
        //         });
        //     });
        // },
        closeEditBox() {
            this.editBoxVisiable = false;
        },
        edit() {
            this.$refs.followUpForm.validate(valid => {
                if (!valid) return;
                let data = cloneDeep(this.followUpData);
                delete data.Contact;
                delete data.transitionDate;
                delete data.tDate;
                if (this.editBoxTitle === '新增跟进') {
                    this.$emit('add', data);
                } else {
                    this.$emit('update', data);
                }
            });
        },
        delFollowItem() {
            if (this.currentFollowId === null) {
                this.$notify({
                    title: '提示',
                    message: '请选择要删除的跟进内容！',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('此操作将永久删除该跟进内容, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('delete', this.currentFollowId);
            }).catch(() => {});
        }
    },
    mounted() {

    }
};


// WEBPACK FOOTER //
// ./src/common/components/follow-up-dialog/vm.js